import { useMemo } from "react";

export interface ThemeColor {
  name: string;
  value: string;
}

export const useThemeColors = (themeString: string): ThemeColor[] => {
  return useMemo(() => {
    if (!themeString) return [];
    
    try {
      const theme = JSON.parse(themeString);
      const colors: ThemeColor[] = [];
      
      const extractColors = (obj: any, prefix: string = "") => {
        for (const [key, value] of Object.entries(obj)) {
          const fullKey = prefix ? `${prefix}.${key}` : key;
          
          if (typeof value === 'string' && value.match(/^#[0-9A-Fa-f]{6}$/)) {
            colors.push({ name: fullKey, value: value });
          } else if (typeof value === 'object' && value !== null) {
            extractColors(value, fullKey);
          }
        }
      };
      
      extractColors(theme);
      return colors;
    } catch (error) {
      return [];
    }
  }, [themeString]);
}; 